import type { GroupPreviewType } from 'models';
import { useCallback } from 'react';
import { CellPhoneIcon, ChurchLineIcon, FolderLineIcon } from 'ui';

export const useGetGroupPreviewIcon = () =>
  useCallback(({ groupType }: { groupType: GroupPreviewType }) => {
    switch (groupType) {
      case 'association':
      case 'denomination':
      case 'district':
      case 'jurisdiction':
      case 'region':
      case 'state_convention':
        return <FolderLineIcon />;
      case 'organization':
        return <ChurchLineIcon />;
      case 'private_label_app':
        return <CellPhoneIcon />;
    }
  }, []);
